import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { RoleService } from '../role.service';

const USER_KEY = 'wt_user';
const TOKEN_KEY = 'edash_auth_token';

export interface User {
    name?: string;
    email?: string;
    accountId?: string;
    timezone?: string;
    roles?: string[];
}
@Injectable({
    providedIn: 'root'
})

export class UserService {
    constructor(
        private cookieService: CookieService,
        private roleService: RoleService
        )
         { }
    private user;

  /**
   * Saves logged in user's email cookie after login
   */
  public saveUser(user: User) {
      this.user = user;         
      this.roleService.setRoles(user.roles);
  }

  /**
   * Returns logged in user's email
   */
  public getUser(): User {
      return this.user || {};
  }

  saveToken(token: string) {      
      this.cookieService.set(TOKEN_KEY, token, undefined, '/');
  }

  deleteTokens() {
      this.cookieService.delete(TOKEN_KEY);
      this.cookieService.delete(USER_KEY);
  }

  getToken() {      
      return this.cookieService.get(TOKEN_KEY);
  }
}
